import React from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import "./../../assets/css/TourIncludes.css";
import {
  BsPersonCheck,
  BsBuilding,
  BsEggFried,
  BsBusFront,
  BsCamera,
  BsAirplane,
} from "react-icons/bs";
import {

  MdDinnerDining ,
} from "react-icons/md";
import TourBookingCard from "./TourBookingCard";

const TourIncludes = ({ packages }) => {
  // Ensure includes is always an array
  let includesArray = [];
  if (Array.isArray(packages?.includes)) {
    includesArray = packages.includes;
  } else if (typeof packages?.includes === "string") {
    try {
      // Try parsing JSON string first
      includesArray = JSON.parse(packages.includes);
      if (!Array.isArray(includesArray)) {
        includesArray = packages.includes
          .split(",")
          .map((i) => i.trim())
          .filter(Boolean);
      }
    } catch {
      // Fallback: comma-separated string
      includesArray = packages.includes
        .split(",")
        .map((i) => i.trim())
        .filter(Boolean);
    }
  } else {
    includesArray = [];
  }

  // Map each include key to an icon and label
  const includeOptions = {
    tour_manager: { icon: <BsPersonCheck />, label: "Tour Manager" },
    hotel: { icon: <BsBuilding />, label: "Hotel" },
    meals: { icon: <MdDinnerDining />, label: "Meals" },
    transport: { icon: <BsBusFront />, label: "Transport" },
    sightseeing: { icon: <BsCamera />, label: "Sightseeing" },
    flight: { icon: <BsAirplane />, label: "Flight*" },
  };

  return (
    <Container className="py-3 tour-details">
      {/* Tour Includes */}
      <section className="mb-5" id="tour-includes">
        <h3 className="Tour-title">Tour Includes</h3>
        <Row className="text-center g-4">
          {includesArray.map((item) => {
            const option = includeOptions[item];
            if (!option) return null; // skip unknown items
            return (
              <Col key={item} xs={6} md={3} lg={2} className="icon-col">
                <div className="icon-box">
                  {option.icon}
                  <p>{option.label}</p>
                </div>
              </Col>
            );
          })}
        </Row>

        {includesArray.includes("flight") && (
          <small className="note text-danger d-block mt-3">
            * Economy class air travel is included for all departure cities, except
            for joining/leaving points. Taxes extra.
          </small>
        )}
      </section>

      <Row>
        <Col lg={12} >
          <section id="tour-highlights">
            <h3 className="Tour-title">Tour Highlights</h3>
            <div
           className="highlights-content"

              dangerouslySetInnerHTML={{ __html: packages?.highlights || "" }}
            />
          </section>
        </Col>     
      </Row>
    </Container>
  );
};

export default TourIncludes;
